export const soapLeftCardSx = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 0,
  boxShadow: 'none',
  border: '1px solid #E4E7EC',
  borderTop: 0,
  borderBottom: 0
};

export const tabsHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  minHeight: 44
};

export const tabListSx = {
  minHeight: 44,
  flex: 1,
  color: '#424242',
  bgcolor: '#FCF8F2',

  '& .MuiTabs-indicator': {
    height: 2,
    backgroundColor: '#4A90D9'
  },

  '& .MuiTab-root': {
    minHeight: 44,
    px: 2.2,
    fontSize: 13,
    fontWeight: 500,
    color: '#424242',
    textTransform: 'none',
    alignItems: 'center'
  },

  '& .Mui-selected': {
    color: '#4E8AC7 !important',
    fontWeight: 700,
    bgcolor: '#FFFFFF'
  }
};

export const documentBadgeSx = {
  '& .MuiBadge-badge': {
    width: 6,
    height: 6,
    minWidth: 6,
    borderRadius: '50%',
    top: 2,
    left: -4
  }
};

export const cardContentSx = {
  p: 0,
  flex: 1,
  minHeight: 0,
  height: 'calc(100vh - 180px)',
  overflow: 'hidden',
  pb: '0px !important'
};

export const tabPanelSx = {
  p: 0,
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const scrollTabPanelSx = {
  p: 0,
  height: '100%',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: '#C5C5C5 transparent',

  '&::-webkit-scrollbar': {
    width: 5
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C5C5C5',
    borderRadius: 10
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#9E9E9E'
  }
};

export const getSoapGridSx = isPast => ({
  display: 'grid',

  gridTemplateColumns: {
    xs: '1fr',
    md: isPast
      ? 'minmax(0, 1fr) minmax(0, 0fr)'
      : 'minmax(0, 1fr) minmax(0, 1fr)'
  },

  columnGap: {
    xs: 0,
    md: isPast ? 0 : 1
  },

  width: '100%',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden',

  transition: theme =>
    theme.transitions.create(
      ['grid-template-columns', 'column-gap'],
      {
        duration: 450,
        easing: theme.transitions.easing.easeInOut
      }
    )
});

export const getSoapEntryColumnSx = isPast => ({
  minWidth: 0,
  minHeight: 0,
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',

  borderRight: {
    xs: 0,
    md: isPast ? 0 : '1px solid #E0E0E0'
  },

  transition: theme =>
    theme.transitions.create('border-color', {
      duration: 300
    }),

  scrollbarWidth: 'thin',

  '&::-webkit-scrollbar': {
    width: 6
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: '#F5F5F5'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C5C5C5',
    borderRadius: 10
  }
});

export const getSoapPastColumnSx = isPast => ({
  minWidth: 0,
  minHeight: 0,
  height: '100%',
  overflow: 'hidden',

  opacity: isPast ? 0 : 1,
  visibility: isPast ? 'hidden' : 'visible',

  transform: isPast
    ? 'translateX(24px)'
    : 'translateX(0)',

  pointerEvents: isPast ? 'none' : 'auto',

  borderLeft: {
    xs: 0,
    md: isPast ? 0 : '1px solid #D9D9D9'
  },

  transition: theme =>
    theme.transitions.create(
      [
        'opacity',
        'transform',
        'visibility',
        'border-color'
      ],
      {
        duration: 350,
        easing: theme.transitions.easing.easeInOut
      }
    )
});

export const documentsWrapperSx = {
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column'
};

export const documentsHeaderSx = {
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  p: 1.5
};

export const documentsTitleWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5
};

export const documentsTitleSx = {
  fontSize: 17,
  fontWeight: 500,
  color: '#212121'
};

export const recordsCountSx = {
  px: 1.5,
  py: 0.5,
  borderRadius: 1,
  bgcolor: '#F5F5F5',
  color: '#424242',
  fontSize: 11,
  fontWeight: 500,
  fontFamily: 'Roboto',
  border: '1px solid #EEEEEE'
};

export const documentsActionsSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  flexShrink: 0
};

export const messageButtonSx = {
  textTransform: 'uppercase',
  borderColor: '#C1DEF2',
  bgcolor: '#E3F2FD',
  color: '#424242',
  fontWeight: 500,

  '& .MuiButton-startIcon': {
    mr: 0.5,
    ml: 0
  },

  '&:hover': {
    borderColor: '#90CAF9',
    bgcolor: '#E3F2FD'
  }
};

export const uploadButtonSx = {
  textTransform: 'uppercase',
  borderColor: '#EFDCB5',
  bgcolor: '#F8F1E2',
  color: '#424242',
  fontWeight: 500,

  '& .MuiButton-startIcon': {
    mr: '2px',
    ml: 0
  },

  '&:hover': {
    borderColor: '#D6B27D',
    bgcolor: '#FFF8EF'
  }
};

export const actionIconSx = {
  fontSize: 18
};